import {
  GET_BUYERS_SUCCESS,
  GET_BUYERS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_BUYERS_SUCCESS: {
      return {
        ...state,
        buyers: action.payload.buyers,
      }
    }

    case GET_BUYERS_FAILURE: {
      return {
        ...state,
        getBuyersError: action.payload.error,
      }
    }

    default:
      return state
  }
}
